export default __webpack_public_path__ + "static/media/users.c8d8ff7d.png";